import React, {
  lazy,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  addEmployeeCertificate,
  getEmployeeCertificate,
} from "../Service/profileService";
import { TostMsg } from "../../../../App";
import * as Yup from "yup";
import { useFormik } from "formik";
import { uploadDoc } from "../../../../Services/Global-Services/GlobalServices";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";
import UploadFile_KEYS from "../../../../Services/Global-Services/UploadFile_Keys";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";

function AddCertification() {
  const { GUID } = useParams();
  const [Isloading, setIsloading] = useState(false);
  const [certificateLst, setCertificateLst] = useState([]);
  const userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [file, setFile] = useState(null);
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [showContent, setSeleteContent] = useState([]);
  const [dateError, setDateError] = useState(false);
  let history = useHistory();

  useEffect(() => {
    if (GUID?.length >= 0) {
       setIsloading(true);
      setTimeout(() => {
         setIsloading(false);
        GetMasterSystemAlertList("Edit_Certificates", 1);        
        GetEmployeeCertificate();
      }, 1000);
    } else {
       setIsloading(false);
      GetMasterSystemAlertList("Add_Certificates", 1);
      certificateForm.resetForm();
    }
  }, []);

  async function GetEmployeeCertificate() {
     setIsloading(true);
    let body = {
      Id: Number(GUID) ?? 0,
      OrgId: userDetails.OrgId,
      EmpId: userDetails?.EmpId,
    };
    try {
      let response = await getEmployeeCertificate(body);
      let CertificateValue = response.Data;
      setCertificateLst(CertificateValue);
      if (CertificateValue[0]?.id) {
        const isPerpetual =
          CertificateValue[0]?.ValidityEndDate === "Perpetual Validity";
        let Certificate = {
          CertificateId: CertificateValue[0]?.id,
          CertificateName: CertificateValue[0].CertificateName,
          IssuingOrg: CertificateValue[0].IssuingOrg,
          CertificateImage: CertificateValue[0].CertificateImage,
          ValidityStartDate: CertificateValue[0].ValidityStartDate.split("T")[0]
            ? new Date(CertificateValue[0].ValidityStartDate)
                .toISOString()
                .split("T")[0]
            : null,
          ValidityEndDate: isPerpetual
            ? ""
            : CertificateValue[0]?.ValidityEndDate
            ? new Date(CertificateValue[0].ValidityEndDate)
                .toISOString()
                .split("T")[0]
            : "",
          currentlyWorkingHere: isPerpetual,
        };
        certificateForm.setValues(Certificate);
         setIsloading(false);
      }
    } catch (error) {
      setIsloading(false);
    }
  }

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setSeleteContent(msg?.Desc);
      } else if (msg?.Name == message && type == 2) {
        setSeleteContent(msg?.Desc);
      }
    });
  }, []);

  const CertificateValidation = Yup.object().shape({
    CertificateName: Yup.string().required("Certificate Name is required."),
    IssuingOrg: Yup.string().required("Organization is required."),
    CertificateImage: "", //Yup.string().required("Image is required."),
    currentlyWorkingHere: Yup.boolean().default(false),
    ValidityStartDate: Yup.date().required("Start date is required"),
    ValidityEndDate: Yup.date()
      .nullable()
      .when("currentlyWorkingHere", {
        is: false, // when checkbox is unchecked
        then: Yup.date()
          .required("End date is required")
          .min(
            Yup.ref("ValidityStartDate"),
            "End date cannot be before start date"
          ),
        otherwise: Yup.date().nullable(), 
      }),
  });

  const certificateForm = useFormik({
    initialValues: {
      CertificateName: "",
      IssuingOrg: "",
      CertificateImage: "",
      ValidityStartDate: "",
      ValidityEndDate: "",
      currentlyWorkingHere: false,
    },
    validationSchema: CertificateValidation,
    onSubmit: async (data) => {
      setIsloading(true);
      const body = {
        Id: data?.CertificateId ?? 0,
        OrgId: userDetails.OrgId,
        EmpId: userDetails.EmpId,
        CertificateName: data.CertificateName,
        IssuingOrg: data.IssuingOrg,
        CertificateImage: data.CertificateImage,
        ValidityStartDate: data.ValidityStartDate,
        ValidityEndDate: data.currentlyWorkingHere
          ? ''
          : data.ValidityEndDate,
        ModifiedBy: userDetails.OrgId,
      };

      try {
        await addEmployeeCertificate(body);
        setIsloading(false);
        if (GUID) {
          GetMasterSystemAlertList("Certificate_Updated", 0);
        } else {
          GetMasterSystemAlertList("Certificate_Added", 0);
        }
        history.push(`/Profile/${userDetails.GUID}`);
        certificateForm.resetForm();
      } catch (err) {
        console.error(err);
      } finally {
        setIsloading(false);
      }
    },
  });

  const setStartDate = (event) => {
    certificateForm.setFieldValue("ValidityEndDate", event);
  };

  const setEndDate = (event) => {
    const startDate = new Date(certificateForm.values.ValidityStartDate);
    const endDate = new Date(event);
    const normalizeDate = (date) => {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };
    const normalizedStartDate = normalizeDate(startDate);
    const normalizedEndDate = normalizeDate(endDate);
    if (normalizedStartDate <= normalizedEndDate) {
      setDateError(false);
    } else {
      setDateError(true);
    }
  };

  const handleFileChange = useCallback(async (event) => {
    const selectedFile = await event.target.files;
    setFile(selectedFile);
  }, []);

  useEffect(() => {
    if (file) {
      uploadPolicyDocFile();
    }
  }, [file]);

  async function uploadPolicyDocFile() {
    setIsloading(true);
    if (file) {
      const formData = new FormData();
      for (let i = 0; i < file.length; i++) {
        formData.append("files", file[i]);
      }
      let params = {
        UploadType: UploadFile_KEYS?.Certificate,
        RefId: certificateLst?.Id ?? 0,
      };
      try {
        setIsloading(true);
        const response = await uploadDoc(params, formData);
        const data = await response;
        const ImageURL = data?.Data;
        certificateForm.setFieldValue("CertificateImage", ImageURL[0]);
        setIsloading(false);
      } catch (error) {
        setIsloading(false);
        toster.current.error(ERROR_LIST.UploadFileError);
      } finally {
        setIsloading(false);
      }
    } else {
      setIsloading(false);
      toster.current.warn("No file selected");
    }
  }

  return (
    <>
      <div className="container-fluid  position-relation">
        <div className="row">
          <div className="col-xl-12">
            <div className="form-head d-flex flex-wrap align-items-center mb-4">
              <div className="me-auto">
                <h2 className="font-w600 mb-0">
                  {" "}
                  {GUID ? "Edit" : "Add"} Certificate
                </h2>
                <p className="text-center">{showContent}</p>
              </div>
              <div className="rightside-tabs">
                <Link to={`/Profile/${userDetails.GUID}`}>
                  <button className="back-newticket w-auto float-right">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      className="bi bi-arrow-left-short"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5"
                      />
                    </svg>{" "}
                    Back
                  </button>
                </Link>
              </div>
            </div>
          </div>
          <div className="col-xl-12">
            <form onSubmit={certificateForm.handleSubmit}>
              <div className="row mt-5 justify-content-center">
                <div className="col-xl-9">
                  <div className="row gy-2 gx-3">
                    <div className="col-xl-8">
                      <div className="row">
                        <div className="mb-3 col-md-12">
                          <div className="cover-form">
                            <label className="form-label">
                              Certificate Name
                              <i className="inValidError">*</i>
                            </label>
                            <input
                              type="text"
                              name="CertificateName"
                              className={
                                "form-control" +
                                (certificateForm.errors.CertificateName &&
                                certificateForm.touched.CertificateName
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={certificateForm.handleChange}
                              value={certificateForm.values.CertificateName}
                              placeholder="Certificate Name"
                            />
                          </div>
                          <div className="invalid-feedback">
                            {certificateForm.errors.CertificateName &&
                            certificateForm.touched.CertificateName
                              ? certificateForm.errors.CertificateName
                              : null}
                          </div>
                        </div>
                        <div className="mb-3 col-md-12">
                          <div className="cover-form">
                            <label className="form-label">
                              Issuing Organization{" "}
                              <i className="inValidError">*</i>
                            </label>
                            <input
                              type="text"
                              name="IssuingOrg"
                              className={
                                "form-control" +
                                (certificateForm.errors.IssuingOrg &&
                                certificateForm.touched.IssuingOrg
                                  ? " is-invalid"
                                  : "")
                              }
                              onChange={certificateForm.handleChange}
                              value={certificateForm.values.IssuingOrg}
                              placeholder="Issuing Organization"
                            />
                          </div>
                          <div className="invalid-feedback">
                            {certificateForm.errors.IssuingOrg &&
                            certificateForm.touched.IssuingOrg
                              ? certificateForm.errors.IssuingOrg
                              : null}
                          </div>
                        </div>
                        <div className="mb-3 col">
                          <div className="cover-form">
                            <label className="form-label">
                              Validity Start<i className="inValidError">*</i>
                            </label>
                            <input
                              type="date"
                              name="ValidityStartDate"
                                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                              className={`form-control ${
                                certificateForm.errors.ValidityStartDate &&
                                certificateForm.touched.ValidityStartDate
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={certificateForm.handleChange}
                              onBlur={certificateForm.handleBlur}
                              value={
                                certificateForm.values.ValidityStartDate || ""
                              }
                            />
                          </div>
                          <div className="invalid-feedback">
                            {certificateForm.touched.ValidityStartDate &&
                              certificateForm.errors.ValidityStartDate}
                          </div>
                        </div>
                        {!certificateForm.values.currentlyWorkingHere && (
                          <div className="mb-3 col-md-6">
                            <div className="cover-form">
                              <label className="form-label">
                                Validity End <i className="inValidError">*</i>
                              </label>
                              <input
                                type="date"
                                name="ValidityEndDate"
                                  onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                className={`form-control ${
                                  certificateForm.errors.ValidityEndDate &&
                                  certificateForm.touched.ValidityEndDate
                                    ? "is-invalid"
                                    : ""
                                }`}
                                onChange={certificateForm.handleChange}
                                onBlur={certificateForm.handleBlur}
                                value={
                                  certificateForm.values.ValidityEndDate || ""
                                }
                              />
                            
                            </div>
                              <div className="invalid-feedback">
                                {certificateForm.touched.ValidityEndDate &&
                                  certificateForm.errors.ValidityEndDate}
                              </div>
                          </div>
                        )}
                        <div className="mb-3 col-md-12">
                          <div className="form-check custom-checkbox checkbox-success check-lg">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customCheckBox"
                              checked={
                                certificateForm.values.currentlyWorkingHere
                              }
                              onChange={(e) =>
                                certificateForm.setFieldValue(
                                  "currentlyWorkingHere",
                                  e.target.checked
                                )
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="customCheckBox"
                            >
                              Currently Valid
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-4">
                      <div className="row">
                        <div className="col-xl-12">
                          <div className="cover-form">
                            <p className="form-label">
                              Upload Certificate
                            </p>
                            <div className="loadresumes">
                              <div className="inner">
                                {certificateForm?.values?.CertificateImage ? (
                                  <img
                                    src={
                                      certificateForm?.values?.CertificateImage
                                    }
                                    className="editaddimg"
                                  />
                                ) : (
                                  <img
                                    src={"/images/org-img/learn/add.png"}
                                    className="editaddimg"
                                  />
                                )}
                              </div>
                              <label
                                htmlFor="file-upload"
                                className="custom-file-upload"
                              >
                                <i
                                  className="fa fa-upload me-2"
                                  aria-hidden="true"
                                ></i>
                                Upload Certificate
                              </label>

                              <input
                                type="file"
                                multiple=""
                                id="file-upload"
                                className="form-control"
                                name="CertificateImage"
                                accept="image/png, image/gif, image/jpeg"
                                style={{ display: "none" }}
                                onChange={(event) => handleFileChange(event, 0)}
                              />
                            </div>
                          </div>
                          <div></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-9">
                  <div className="btns-grp">
                    <Link to={`/Profile/${userDetails.GUID}`}>
                      <button
                        className="add-click"
                        style={{ width: "115px" }}
                        fdprocessedid="5mw059"
                      >
                        Cancel
                      </button>
                    </Link>
                    {GUID ? (
                      <button
                        type="submit"
                        className="savebutton"
                        fdprocessedid="jjj57m"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Update"}
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="savebutton"
                        fdprocessedid="jjj57m"
                        disabled={Isloading}
                      >
                        {Isloading ? "Please wait..." : "Save"}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        {Isloading ? (
          <Suspense>
            <ComponentLoader />
          </Suspense>
        ) : (
          ""
        )}
      </div>
    </>
  );
}

export default AddCertification;
